// views/MainPage/HomePage/HomePage.tsx
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './HomePage.module.css';
import { Beacon, BeaconEventType, ReferralCode } from '../../../Entities';
import { deleteUrlParam, validateReferralCode } from '../../../utils/helpers';

import HeroSection from './components/HeroSection/HeroSection';
import StatsStrip from './components/StatsStrip/StatsStrip';
import HowSection from './components/HowSection/HowSection';
import TrySection from './components/TrySection/TrySection';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import PricingSection from './components/PricingSection/PricingSection';
import FaqSection from './components/FaqSection/FaqSection';
import FinalCta from './components/FinalCta/FinalCta';
import { notify } from '../../../components/common/Toast/toastBridge';
import TemporaryOutOfOrder from './components/TemporaryOutOfOrder/TemporaryOutOfOrder';

const HomePage = () => {
  const [referralCode, setReferralCode] = useState<ReferralCode | null>(null);
  const navigate = useNavigate();

  const redirectToRegisterPage = useCallback(() => {
    Beacon.addEvent(BeaconEventType.ON_ACTION_BUTTON_CLICKED);
    navigate('/register');
  }, [navigate]);

  useEffect(() => {
    validateReferralCode().then((referralCode: ReferralCode | null) => setReferralCode(referralCode));
  }, []);

  return (
    <div className={styles.homePage} id="top">
      {/* <button className={styles.floatingBtn} onClick={redirectToRegisterPage} title="Začít brigádu">
        Začít brigádu
      </button> */}

      {/* <HeroSection redirectToRegisterPage={redirectToRegisterPage} />
      <StatsStrip />
      <HowSection />
      <TrySection />
      <PricingSection redirectToRegisterPage={redirectToRegisterPage} />
      <FeaturesSection />
      <FaqSection />
      <FinalCta redirectToRegisterPage={redirectToRegisterPage} /> */}
      <TemporaryOutOfOrder/>
    </div>
  );
};

export default HomePage;
